export default __webpack_public_path__ + "aerialFARMS_flat.svg?848132ace8ac36f2f1878f333a1972f0";